export var apiConfig = {
	protocol : 'https:/',
	domain: 'api-adresse.data.gouv.fr',
	path: ''
}
